// Géocodage côté navigateur via Nominatim (OpenStreetMap).
// Effectué depuis le navigateur de l'utilisateur (et non le serveur) pour
// respecter la politique d'usage de Nominatim et éviter le blocage d'IP
// partagée côté serveur. Sans restriction de pays (fonctionne FR, CH, BE...).

export async function geocodeAddress({ adresse, code_postal, ville }) {
  const parts = [adresse, code_postal, ville]
    .filter((p) => p && p.trim())
    .map((p) => p.trim());
  if (parts.length === 0) return null;

  const query = encodeURIComponent(parts.join(', '));
  const res = await fetch(
    `https://nominatim.openstreetmap.org/search?q=${query}&format=json&limit=1&addressdetails=0`,
    { headers: { 'Accept-Language': 'fr' } }
  );
  if (!res.ok) {
    throw new Error(`Nominatim ${res.status}`);
  }
  const data = await res.json();
  if (Array.isArray(data) && data.length > 0) {
    return {
      latitude: parseFloat(data[0].lat),
      longitude: parseFloat(data[0].lon),
    };
  }
  return null;
}

export const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
